<template>
  <ux-form
    ref="form"
    :data="formData"
    :rules="rules"
    label-width="auto"
    data-automation="bindEmail"
  >
    <ux-form-item :label="$t('HT.addUser.nickname')" required prop="changeNickname">
      <ux-input
        v-model="formData.changeNickname"
        size="small"
        :maxlength="20"
        :placeholder="$t('HT.addUser.nickname.placeholder')"
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          changeNickname: ''
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.register(this)
    };
  },

  methods: {
    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.formData);
        }
      });
    }
  }
};
</script>
